module.exports = " <div class=\"panel panel-primary float margin-top margin-bottom\"> <div class=panel-heading> <h3 class=panel-title> <slot name=title></slot> </h3> </div> <div class=panel-body> <slot name=buttons></slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuHome.vue
 ** module id = 289
 ** module chunks = 1
 **/